import router from "@/router/index";


/**
 * 面包屑使用
 * 遍历树 为每个节点添加父节点信息
 */
const addParentInfo = data => {
    data.forEach(item => {
        if (item.children && item.children.length > 0) {
            item.children.forEach(child => {
                child.parentInfo = {title: item.title, icon: item.icon};
            })
            addParentInfo(item.children)
        }
    })
};

/**
 * 遍历树形结构 生成一维路由
 * @param data
 */
const openTreeToArray = data => {
    let array = [];
    data.forEach(item => {
        array.push(item);
        if (item.children && item.children.length > 0) {
            array.push(...openTreeToArray(item.children))
        }
    })
    return array;
};

/**
 * 添加动态路由
 * @param data
 */
let removeDynamicRoutes = [];

const clearDynamicRoutes = () => {
    removeDynamicRoutes.forEach(removeRoute => removeRoute());
    removeDynamicRoutes = [];
};

const appendDynamicRoutes = data => {

    // A login in the same SPA session must replace the previous user's routes,
    // rather than retaining another copy of the entire route tree.
    clearDynamicRoutes();

    addParentInfo(data);

    let array = openTreeToArray(data);
    const routes = [];
    array.forEach(item => {
        // 路径为空 或 被停用
        if (!item.path || item.state === 0) {
            return
        }
        let route = {
            path: item.path,
            name: `dynamic:${item.path}`,
            component: () => import(`@/pages/${item.component}`),
            meta: {
                title: item.title,
                permission: item.prems,
                icon: item.icon,
                visible: item.visible,
                parentInfo: item.parentInfo,
                params: item.query
            }
        }
        routes.push(route)
    })

    routes.push(...[
        {// 修改密码
            path: '/change/password',
            name: 'dynamic:change-password',
            component: () => import('@/pages/ChangePassword'),
        },
        {// 500
            path: "/500",
            name: 'dynamic:error-500',
            component: () => import('@/pages/error/500')
        },
        {// 403
            path: "/403",
            name: 'dynamic:error-403',
            component: () => import('@/pages/error/403')
        },
        {// 404页面
            path: "/:pathMatch(.*)*",
            name: 'dynamic:not-found',
            component: () => import('@/pages/error/404')
        }])

    removeDynamicRoutes = routes.map(route => router.addRoute('layout', route));
};

export default {appendDynamicRoutes, clearDynamicRoutes};
